import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Input, Tag, Pagination } from "antd";
import { SearchOutlined, EyeOutlined } from "@ant-design/icons";
import { loadingPlanService } from "../../../services";
import { Link } from "react-router-dom";
import { useDebounce } from "../../../hooks/useDebounce";
import { GoDotFill } from "react-icons/go";
import { withDefaultRender } from "../../../utils/tableDefaultRender";

function Loadedplan() {
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [search, setSearch] = useState(null)
  const debouncedSearch = useDebounce(search, 500);

  const columns = withDefaultRender(
    [
      {
        title: "S.No",
        dataIndex: "s.no",
        key: "s.no",
        render: (text, record, index) => index + 1,
      },
      {
        title: "id",
        dataIndex: "id",
        key: "id",
        //   render: (text, record, index) => index + 1,
      },
      {
        title: "Invoice No",
        dataIndex: "invoice_no",
        key: "invoice_no",
        render: (text) =>
          text ?
            (<a
              href={`/invoice/view/${text}`}
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-primary hover:text-primary hover:underline"
            >
              {text}
            </a>) :
            ("-")
      },
      {
        title: "Container Id",
        dataIndex: "container_id",
        key: "container_id",
      },
      {
        title: "Booking Number",
        dataIndex: "booking_no",
        key: "booking_no",
      },
      {
        title: "Container Number",
        dataIndex: "c_container_number",
        key: "c_container_number",
      },
      {
        title: "Location",
        dataIndex: "location",
        key: "Location",
      },
      // {
      //   title: "Status",
      //   dataIndex: "status",
      //   key: "status",
      //   render: (text, record) =>
      //     <Tag color={record?.is_client_approved_loadplan === 0 && record?.reject === 0 ? "yellow" :
      //       record?.reject === 1 ? "red" :
      //         "green"}>
      //       {record?.is_client_approved_loadplan === 0 && record?.reject === 0 ? "Pending" :
      //         record?.reject === 1 ? "Rejected" :
      //           "Approved"
      //       }
      //     </Tag>
      // },
      {
        title: "Actions",
        key: "Actions",
        render: (text, record, { _id }) => (
          <Space size="small">
            {/* <Button type="primary" size="small">
            <SendOutlined />
          </Button> */}
            <Link to={`/customers-portal/load-plan/views/${record.container_id}`} className="hover:text-primary">
              {/* <Button type="primary" size="small"> */}
              <EyeOutlined style={{ fontSize: "16px" }} />
              {/* </Button> */}
            </Link>
            {/* <Button type="primary" size="small">
            <DeleteOutlined />
          </Button> */}
          </Space>
        ),
      },
    ])
  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await loadingPlanService.fetchCustomerLoadPlan(
      page,
      null,
      debouncedSearch
    );
    setLoading(false);
    if (success) {
      setPlans(data.containers.data);
      setPagination((prev) => ({
        ...prev,
        total: data.containers.total,
        current: page,
        pageSize,
      }));
    }
  };
  useEffect(() => {
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);

  return (
    <>
      <h1 className='mt-5 mb-6 text-sm font-normal uppercase flex items-center gap-2'><span><GoDotFill style={{ color: "#B83D3D" }} /></span>
        Loaded Containers</h1>
      <div
        style={{
          padding: "8px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div className="flex justify-end">
          <Input
            placeholder="Search by Container no, Booking no"
            prefix={<SearchOutlined />}
            style={{ width: "29%", borderRadius: "24px", height: "40px" }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <Table
          columns={columns}
          scroll={{ x: "max-content" }}
          dataSource={plans}
          loading={loading}
          pagination={false}
          // pagination={{
          //   current: pagination.current,
          //   total: pagination.total,
          //   pageSize: pagination.pageSize,
          //   onChange: (page) => initialize(page, pagination.pageSize),
          //   showSizeChanger: false,
          // }}
          footer={() => (
            <div className="flex justify-between items-center mt-0 mb-0 px-0">
              <div className="text-xs text-gray-600">
                Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                {pagination.total} entries
              </div>

              <Pagination
                current={pagination.current}
                total={pagination.total}
                pageSize={pagination.pageSize}
                showSizeChanger={false}
                onChange={(page) => initialize(page, pagination.pageSize, search)}
                itemRender={(current, type, originalElement) => {
                  if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                  if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                  return originalElement;
                }}
              />
            </div>
          )}
          style={{ marginTop: "5px" }}
        />
      </div >
    </>

  );
}
export default Loadedplan;
